import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import GuestWrapper from './GuestWrapper';
import Routes from './Routes';

const AppRouter = () => {
  const renderWrapper = () => {
    return (
      <GuestWrapper>
        <Routes />
      </GuestWrapper>
    );
  };

  return <BrowserRouter>{renderWrapper()}</BrowserRouter>;
};

export default AppRouter;
